export class NumberResponse {
  object = 'numberResponse';
  value: number;
}
